/**
 * Converts "rgb(R, G, B)" to [R, G, B] format
 * @param {string} rgb RGB string
 * @returns {number[]} Array of RGB values
 */
export const rgbStringToRgbArray = (rgb: string) => {
  const values = rgb.replace(/[^\d,]/g, '').split(',');

  if (values.length !== 3) return [];

  return values.map(Number);
};

/**
 * Converts [R, G, B] to hex string "#rrggbb"
 * @param {number[]} rgb Array of RGB values
 * @returns {string} Hex string
 */
export const rgbArrayToHex = (rgb: number[]) => {
  if (rgb.length !== 3) return '';

  return '#' + rgb.map((value) => value.toString(16).padStart(2, '0')).join('');
};

/**
 * Converts "#rrggbb" to [R, G, B] format
 * @param {string} hex Hex string
 * @returns {number[]} Array of RGB values
 */
export const hexToRgbArray = (hex: string) => {
  if (hex.length !== 7) return [];

  return [
    Number.parseInt(hex.slice(1, 3), 16),
    Number.parseInt(hex.slice(3, 5), 16),
    Number.parseInt(hex.slice(5, 7), 16),
  ];
};
